import { render } from "./PaymentDelete.vue?vue&type=template&id=535017c4&scoped=true"
import script from "./PaymentDelete.vue?vue&type=script&lang=js"
export * from "./PaymentDelete.vue?vue&type=script&lang=js"

import "./PaymentDelete.vue?vue&type=style&index=0&id=535017c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535017c4"]])

export default __exports__